import { useEffect, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import {
  createReport,
  updateReport,
  deleteReport,
  getReportsByFormId,
  Report,
} from '../../../services/report/ReportService';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useReports = (formId?: string, organizationId?: string) => {
  const [currentFormId, setCurrentFormId] = useState(formId);
  const [currentOrganizationId, setCurrentOrganizationId] = useState(organizationId);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentReports, setCurrentReports] = useState<Report[]>();

  useEffect(() => {
    if (!currentFormId || !currentOrganizationId) {
      // TODO Set invalid properties
      return;
    }

    setIsLoading(true);
    loadAsync();
  }, [currentFormId, currentOrganizationId]);

  const loadAsync = async () => {
    try {
      if (currentOrganizationId && currentFormId) {
        const { data } = await getReportsByFormId(currentOrganizationId, currentFormId);
        setCurrentReports(data);
      }
    } catch (error) {
      handleError(error);
    }
    setIsLoading(false);
  };

  const _createReport = async (organizationId: string, formId: string, report: Report) => {
    try {
      const { data } = await createReport(organizationId, formId, report);
      return data;
    } catch (error) {
      handleError(error);
    }
  };

  const _updateReport = async (organizationId: string, formId: string, report: Report) => {
    try {
      const { data } = await updateReport(organizationId, formId, report);
      return data;
    } catch (error) {
      handleError(error);
    }
  };

  const _deleteReport = async (organizationId: string, formId: string, reportId: string) => {
    try {
      const { data } = await deleteReport(organizationId, formId, reportId);
      return data;
    } catch (error) {
      handleError(error);
    }
  };

  return {
    reports: currentReports,
    setReports: setCurrentReports,
    reloadReports: loadAsync,
    createReport: _createReport,
    updateReport: _updateReport,
    deleteReport: _deleteReport,
    setFormId: setCurrentFormId,
    setOrganizationId: setCurrentOrganizationId,
    isLoading,
  };
};

export default useReports;
